// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__28WBV","search":"Settings_search__fd_00","filter":"Settings_filter__22p5S"};